<template>
  <div style="z-index: 99999">
    <el-dialog
      :visible.sync="dialogVisible"
      width="35%"
      :show-close="true"
      :close-on-click-modal="false"
    >
      <div class="charge-field">
        <div class="charge-box">
          <div class="charge-title"><span>充值余额</span></div>

          <div class="order-info">
            <div class="order-tit">本次订单需充值金额</div>
            <div class="order-detail">
              <div class="order-name">
                充值订单号：
                <span class="high"> {{ this.rechargeForm.serialNum }}</span>
              </div>

              <div class="charge-money">
                <em>￥</em
                ><span class="rechargemoney">{{
                  this.rechargeForm.amount
                }}</span>
              </div>
            </div>
          </div>
          <div class="charge-info">
            <div class="charge-item">
              <div class="charge-ctn qrcode-ctn">
                <div id="qrcode" align="center">
                  <div id="qrcode" ref="qrCodeDiv"></div>
                </div>
              </div>
            </div>
            <div class="paid-tips">
              若您已支付成功，请点击
              <el-button type="text" @click="ConfirmPayment()" v-preventClick>
                我已支付
              </el-button>
            </div>
            <div class="warning-txt" style="text-align: center">
              温馨提示：如未及时到账，请联系客服
            </div>
          </div>
          <div class="bottom-tips">
            <div class="tips">
              严禁任何机构或个人利用收款码进行诈骗，如有发现请联系客服
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <van-dialog
      title="支付提示"
      v-model="dialogPayTipVisible"
      show-cancel-button
      confirmButtonText="我已支付"
      cancelButtonText="取消支付"
      @confirm="ConfirmPayment()"
      :before-close="newGroupBefColse"
    >
      <div style="padding: 20px; text-align: center">请确认支付信息</div>
    </van-dialog>
  </div>
</template>

<script>
import {
  create,
  zhuanzhangRecharge,
  queryRechargeStatus,
} from "@/api/recharge";

import QRCode from "qrcodejs2";

import { getUserId } from "@/utils/auth";

export default {
  name: "Payment",
  props: {
    payConfig: {
      type: Object,
    },
    amount: {
      type: Number, //充值金额
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      serialNum: undefined,
      userId: getUserId(),
      srcList: [],
      stepsActive: 1,
      dialogZhuanZhangVisible: false,
      dialogPayTipVisible: false,
      dialogVisible: false,
      payDetails: {},
      outTradeNo: undefined,
      rechargeForm: undefined,
    };
  },
  methods: {
    newGroupBefColse(action, done) {
      if (action == "confirm") {
        done(false);
      } else {
        done();
      }
    },

    //在线支付
    toPayment() {
      if (!this.amount) {
        this.$message({
          message: "请填写充值金额",
          type: "info",
        });
        return;
      }

      //统一参数
      let data = {
        amount: this.amount,
        payId: this.payConfig.payId,
      };

      //在线支付
      if (this.payConfig.payMethod != 3) {
        new Promise((resolve, rejust) => {
          create(data)
            .then((res) => {
              let returnType = res.result.returnType;

              let returnUrl = res.result.returnUrl;

              //1:跳转支付
              if (returnType == 1) {
                // window.open(returnUrl, "_blank");
                setTimeout(() => window.open(returnUrl, "_blank"));
              }

              //二维码扫码支付
              if (returnType == 2) {
                this.dialogVisible = true;
                this.GenerateQRCode(returnUrl);
              }

              this.rechargeForm = res.result.rechargeForm;

              resolve();
            })
            .catch((error) => {
              rejust(error);
            });
        });
      }

      //转账支付
      if (this.payConfig.payMethod === 3) {
        new Promise((resolve, rejust) => {
          zhuanzhangRecharge(data)
            .then((res) => {
              let rechargeId = res.result;
              if (res.status == 0) {
                if (this.isMobile) {
                  this.$router.push(
                    `/mselfPay/${this.payConfig.payId}/${rechargeId}`
                  );
                } else {
                  this.$router.push(
                    `/selfPay/${this.payConfig.payId}/${rechargeId}`
                  );
                }
              }
              resolve();
            })
            .catch((error) => {
              rejust(error);
            });
        });
        return;
      }
    },

    /**
     * 确认支付
     */
    ConfirmPayment() {
      this.loopOrderState();
    },

    // 生成二维码
    GenerateQRCode(qrCode) {
      this.delQrcode();

      var that = this;
      setTimeout(() => {
        new QRCode(that.$refs.qrCodeDiv, {
          text: qrCode,
          width: 200,
          height: 200,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      }, 0);
    },

    //查询当前余额充值状态s
    loopOrderState() {
      new Promise((resolve, rejust) => {
        let data = {
          serialNum: this.rechargeForm.serialNum,
        };
        queryRechargeStatus(data)
          .then((res) => {
            if (res.result == 1) {
              this.$message({
                message: "充值成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.dialogPayTipVisible = false;
              this.$store.dispatch("user/info").then();
              clearInterval(this.T);
            }

            resolve();
          })
          .catch((error) => {
            rejust(error);
          });
      });
    },

    // 清空二维码,避免生成多个二维码
    delQrcode() {
      setTimeout(() => {
        this.$refs.qrCodeDiv.innerHTML = "";
      }, 0);
    },
  },
};
</script>

<style scoped>
/* 新的 */

.charge-field .charge-box {
  position: relative;
  overflow: hidden;
  border-radius: 2px;
  margin: 0 auto;
  top: 50%;
  background-color: #fff;
  /* -webkit-box-shadow: 0px 18px 40px 0px rgba(51, 51, 51, .18); */
  /* box-shadow: 0 18px 40px #3333332e; */
  padding-top: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 1;
}

.charge-field .charge-box .charge-title {
  font-size: 18px;
  font-weight: 700;
  color: #4d4d4d;
  position: relative;
  text-align: center;
  margin-bottom: 24px;
  line-height: 24px;
}

.charge-field .charge-box .charge-title .close-btn {
  position: absolute;
  width: 10px;
  height: 10px;
  top: -18px;
  right: 10px;
  cursor: pointer;
  padding: 10px;
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/order-pop-close.a86bce47.png)
    no-repeat;
  background-position: center center;
}

.charge-field .charge-box .order-info {
  padding: 0 20px;
}

.charge-field .charge-box .order-info .order-tit {
  margin-bottom: 16px;
  font-size: 12px;
  display: none;
}

.charge-field .charge-box .order-info .order-detail {
  background-color: #f7f8fc;
  padding: 16px 0;
  text-align: center;
}

.order-detail .order-name {
  font-size: 14px;
  color: #4d4d4d;
  line-height: 24px;
}

.order-detail .order-name .high {
  color: #ff893d;
}

.charge-field .charge-box .order-info .order-detail .money-item {
  display: inline-block;
  line-height: 16px;
  margin-right: 24px;
  font-size: 12px;
  color: #4d4d4d;
}

.charge-field .charge-box .order-info .order-detail .money-item:last-child {
  margin-right: 0;
}

.charge-field .charge-box .order-info .order-detail .charge-money {
  font-size: 32px;
  color: #ff3d3d;
  font-weight: 700;
  height: 24px;
  line-height: 24px;
  margin: 13px 0 16px;
}

.charge-field .charge-box .order-info .order-detail .charge-money em {
  font-size: 16px;
  font-style: normal;
}

.charge-field .charge-box .order-info .order-tips {
  margin-top: 12px;
  text-align: left;
  font-size: 12px;
  color: #555;
}

.charge-field .charge-box .order-info .order-tips em {
  font-size: 14px;
  color: #fc3737;
  font-style: normal;
}

.charge-field .charge-box .charge-info {
  margin-top: 30px;
}

.charge-field .charge-box .charge-info .charge-label {
  color: #888;
  width: 80px;
}

.charge-field .charge-box .charge-info .balance-ctn {
  font-size: 14px;
}

.charge-field .charge-box .charge-info .balance {
  color: #fc3737;
  font-size: 16px;
}

.charge-field .charge-box .charge-info .qrcode-box {
  width: 170px;
  height: 170px;
  border: 1px solid #e6e6e6;
  position: relative;
  padding: 4px;
  box-sizing: border-box;
  margin: 12px auto 0;
}

.charge-field .charge-box .charge-info .msg_panel {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 150px;
  margin-left: -75px;
  line-height: 20px;
  background: #bbb;
  color: #fff;
  text-align: center;
  padding: 3px 0;
  transform: translateY(-50%);
}

.charge-field .charge-box .charge-info .qrcode-box .qrcode {
  width: 100%;
  height: 100%;
  vertical-align: top;
}

.charge-field .charge-box .charge-info .tips-wx {
  position: relative;
  color: #fc3737;
  cursor: pointer;
  text-align: center;
  margin-top: 9px;
}

.charge-field .charge-box .charge-info .warning-txt {
  height: 32px;
  font-size: 12px;
  color: #999;
  line-height: 16px;
  margin: 12px 20px 0;
}

.charge-field .charge-box .charge-info .warning-txt .high {
  color: #262626;
}

.charge-field .charge-box .charge-info .refresh-btn {
  color: #fc3737;
}

.charge-field .charge-box .charge-info .refresh-wxtips {
  font-size: 12px;
  line-height: 24px;
  cursor: auto;
}

.charge-field .charge-box .charge-info .tips-txt {
  line-height: 16px;
  font-size: 12px;
  color: #555;
}

.charge-field .charge-box .charge-info .tips-wx:hover .tipx-txt {
  display: block;
}

.charge-field .tips-wx .tipx-txt {
  width: 150px;
  position: absolute;
  left: -32px;
  top: 37px;
  border: 1px solid #e9e9e9;
  padding: 5px;
  font-size: 12px;
  color: #666;
  line-height: 16px;
  border-radius: 3px;
  text-align: justify;
  box-shadow: 0 0 10px #e9e9e9;
}

.charge-field .tips-wx .tipx-txt:before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: #fff;
  transform: rotate(45deg);
  left: 72px;
  top: -6px;
  border: 1px solid #e9e9e9;
  border-bottom: 0px;
  border-right: 0px;
}

.charge-field .charge-box .charge-info .charge-type {
  flex: 1;
}

.charge-field .charge-box .charge-info .charge-type .type-item {
  width: 116px;
  height: 40px;
  margin: 0 0 20px 20px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  user-select: none;
  padding: 0 8px;
  cursor: pointer;
  list-style: none;
  display: inline-flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
}

.charge-field .charge-box .charge-info .charge-type .re-icon {
  width: 32px;
  height: 32px;
  display: inline-block;
  margin-right: 4px;
}

.charge-field .charge-box .charge-info .charge-type .hover {
  border: solid 1px #fc3737;
}

.charge-field .charge-box .charge-info .charge-type .hover:after {
  position: absolute;
  content: "";
  width: 16px;
  height: 16px;
  bottom: 0;
  right: 0;
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-position: 0 0;
}

.charge-field .charge-box .charge-tips {
  font-size: 12px;
  color: #fc3737;
  margin-top: 22px;
}

.charge-field .charge-box .bottom-tips {
  font-size: 12px;
  margin-top: 24px;
  color: #ff893d;
  line-height: 16px;
  background: #fff6ee;
  text-align: center;
  padding: 8px 0;
}

.charge-field .charge-box .bottom-tips .high {
  font-weight: 700;
}

.charge-field .charge-box .bottom-tips .leftmoney {
  color: #fc3737;
}

.charge-field .charge-box .charge-info .charge-type .type-item > div {
  overflow: hidden;
}

.charge-field .charge-box .charge-info .charge-type .type1001 {
  background-image: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon_zfb.png);
  background-size: 34px 34px;
}

.charge-field .charge-box .charge-info .charge-type .type2001 {
  background-image: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon_wx.png);
  background-size: 34px 34px;
}

.charge-field .charge-box .charge-info .charge-type .type6001 {
  background-image: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon_ysf.png);
  background-size: 34px 34px;
}

.charge-field .charge-box .charge-info .charge-type .type10011 {
  background-image: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon_hb.png);
  background-size: 34px 34px;
}

.charge-field .charge-box .charge-info .charge-type .item-top {
  display: flex;
  align-items: center;
}

.charge-field .charge-box .charge-info .charge-type .re-name {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #262626;
  line-height: 19px;
}

.charge-field .charge-box .charge-info .charge-type .re-name > span {
  font-size: 12px;
  color: #fc3737;
  background: #ffeeee;
  border-radius: 10px 10px 10px 0;
  height: 20px;
  line-height: 20px;
  padding: 0 6px;
  margin-left: 6px;
}

.charge-field .charge-box .charge-info .charge-type .re-tip {
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 4px;
}

.paid-tips {
  font-size: 12px;
  color: #4d4d4d;
  line-height: 16px;
  text-align: center;
  margin-top: 16px;
}

.paid-tips .paid-btn {
  cursor: pointer;
  color: #ff372b;
}

.layer-anim111 {
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 19991017;
  width: 500px;
  height: 400px;
}

.pay_content {
  width: 90%;
  height: 290px;
  margin: 0 auto;
}

.pay_content_left {
  width: 43%;
  float: left;
}

.pay_content_right {
  width: 55%;
  float: right;
  margin-top: 20px;
}

.pay_ewm {
  width: 100%;
  height: 200px;
  text-align: center;
  line-height: 200px;
  border: 1px solid #f6f6f6;
}

.pay_ewm img {
  max-width: 100%;
  max-height: 200px;
}

.pay_xz {
  background: #bdbdbd;
  height: 40px;
  width: 100%;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-weight: 700;
}

.pay_xz div {
  width: 50%;
  float: left;
  cursor: pointer;
}

.p_active_xz {
  background: #02a9e9;
}

.pay_content_right p {
  line-height: 50px;
  padding-left: 10px;
}

.pay_content_right p span {
  float: right;
  padding-right: 10px;
  font-size: 20px;
  color: red;
}

.pay_content_right p em {
  font-style: normal;
  color: red;
}

.pay_zzc {
  position: fixed;
  z-index: 998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #0000004d;
}
</style>
